import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FineUploaderFileInput from 'react-fine-uploader/file-input'
import FineUploaderTraditional from 'fine-uploader-wrappers'
import isArray from 'lodash/isArray'

import ProgressBar from './ProgressBar'
import Upload from './Upload'

export class FileInput extends Component {
  static propTypes = {
    multiple: PropTypes.bool,
    value: PropTypes.any,
    onChange: PropTypes.func,
    accept: PropTypes.string,
    maxFiles: PropTypes.number,
    maxFileSize: PropTypes.number,
    displayButtonAlways: PropTypes.bool,
  }

  static defaultProps = {
    multiple: false,
    displayButtonAlways: false,
    onChange: () => {},
  }

  componentWillMount() {
    this.uploader = new FineUploaderTraditional({
      options: {
        request: {
          endpoint: '/tank/uploads/endpoint.json',
          customHeaders: {
            'X-Csrf-Token': window.CSRF_TOKEN,
          },
        },
        callbacks: {
          onComplete: this.handleFileUploaded,
          onError: this.handleUploadError,
        },
      },
    })
  }

  handleFileUploaded = (id, name, response) => {
    if (response.success) {
      this.handleReceivedUpload({ id: response.uuid, name })
    }
  }

  handleUploadError = (id, name, errorReason) => {
    alert(`An error occurred while uploading ${name} -  ${errorReason}`)
  }

  handleReceivedUpload = (upload) => {
    if (!this.props.multiple) {
      this.props.onChange(upload)
    } else {
      let value = append(this.props.value, upload)
      if (this.props.maxFiles) {
        value = value.slice(0, this.props.maxFiles)
      }
      this.props.onChange(value)
    }
  }

  handleRemoveUpload = (upload) => {
    if (!this.props.multiple) {
      this.props.onChange(null)
    } else {
      this.props.onChange(this.props.value.filter((item) => item !== upload))
    }
  }

  render() {
    const uploads = castArray(this.props.value)
    const displayButton =
      this.props.displayButtonAlways ||
      !uploads.length ||
      (this.props.multiple && !this.props.maxFiles) ||
      (this.props.maxFiles && uploads.length < this.props.maxFiles)

    return (
      <React.Fragment>
        {uploads.length > 0 && (
          <div
            className="margin-bottom-xsmall"
            style={{
              display: 'grid',
              gridGap: '2rem',
              gridTemplateColumns: 'repeat(auto-fill, minmax(1rem, 20rem))',
            }}
          >
            {uploads.map((upload, i) => (
              <Upload key={i} upload={upload} onRemove={this.handleRemoveUpload} />
            ))}
          </div>
        )}
        {displayButton && (
          <React.Fragment>
            <div className="flex align-items-center">
              <div className="flex-none">
                <FineUploaderFileInput
                  multiple={this.props.multiple}
                  accept={this.props.accept || undefined}
                  uploader={this.uploader}
                >
                  {this.props.children}
                </FineUploaderFileInput>
              </div>
              <div className="flex-auto margin-left-xsmall">
                <ProgressBar uploader={this.uploader} />
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    )
  }
}

function append(list = [], value) {
  return [...list, value]
}

function castArray(value) {
  if (!value) return []
  return isArray(value) ? value : [value]
}
